import { useIsMobile, useIsTouchDevice, useMediaQuery } from "@salestrak/ui";

// A phone stays a phone in landscape: `useIsMobile()` buckets by CURRENT width
// (< 800), so rotating a phone to landscape (~850px) crosses into the tablet
// bucket and would unlock desktop-only surfaces mid-session. Device class from
// the smallest viewport dimension is rotation-stable; the touch requirement
// keeps short desktop browser windows (mouse, height < 600) on the full
// experience. Phones cap near 440 logical px on their short edge and tablets
// start at 744 (iPad mini), so 600 sits safely between the classes.
//
// Use this instead of `useIsMobile()` to gate surfaces that must NEVER render
// on a phone (e.g. the automations builder canvas). Strictly a superset of
// `useIsMobile()` — everything mobile-bucketed is also phone-class.
//
// `Math.min(width, height) < 600` is expressed as a media query
// (`width < 600 OR height < 600`) rather than by reading dimensions from a
// provider: the derived boolean is all this hook needs.
const PHONE_SMALLEST_DIMENSION_QUERY =
  "(max-width: 599px), (max-height: 599px)";

export function useIsPhoneClass(): boolean {
  const isMobile = useIsMobile();
  const isTouch = useIsTouchDevice();
  const isSmallestDimensionPhoneSized = useMediaQuery(
    PHONE_SMALLEST_DIMENSION_QUERY,
  );
  return isMobile || (isTouch && isSmallestDimensionPhoneSized);
}
